<template>
		<div class="msg-normal">
			<div class="head"><img :src="msg.content.content.user.avatar" /></div>
			<div class="content">
				<div class="user">
					<div class="role" v-if="msg.content.content.user.user_type == '2'">直播助理</div>
					<div class="name">{{ msg.content.content.user.nick_name }}</div>
				</div>
				<div
					class="redpacket"
					:style="{ opacity: msg.content.content.redpacket.surplus_num == 0 || msg.hasRecieved == true ? 0.5 : 1.0 }"
					@click="clickRed"
				>
					<div class="redpacket-content">
						<div class="redpacket-icon">
							<img src="../image/redpacket-icon.png" alt="" />
						</div>
						<div class="redpacket-desc">
							<div class="redpacket-title">{{ msg.content.content.redpacket.title }}</div>
							<div class="recieve" v-if="!msg.hasRecieved">
								{{ msg.content.content.redpacket.surplus_num == 0 ? "红包已被领完" : "领取红包" }}
							</div>
							<div class="recieve" v-if="msg.hasRecieved">{{ "已领取" }}</div>
						</div>
					</div>
					<div class="redpacket-type">{{ msg.content.content.redpacket.type == 1 ? "普通红包" : "口令红包" }}</div>
				</div>
			</div>
		</div>
</template>

<script>
export default {
	props: {
		msg: {
			type: Object,
			required: true,
		},
	},
	watch:{
         msg:function(newV,oldV){
			// console.log(newV.content.redpacket.id,newV.content.redpacket.surplus_num)
		},
	},
	methods:{
		clickRed(){
			this.$emit("clickRed",this.msg.content.content)
		},
	},
};
</script>

<style lang="less" scoped>
@import "../chat.less";
.msg-normal {
	width: 88%;
	height: auto;
	.flex-r-start-c-start;
	> .head {
		width: 36px;
		height: 36px;
		border-radius: 32px;
		border: 1px solid #434043;
		overflow: hidden;
	}
	> .content {
		width: 0;
		flex: 1;
		margin-left: 10px;
		.flex-c-start-r-start;
		> .user {
			.flex-r-start-c-center;
			> .role {
				background-color: #00abea;
				padding: 4px 5px 3px 5px;
				border-radius: 2px;
				color: #fff;
				font-size: 10px;
				line-height: 1;
				margin-right: 5px;
			}
			> .name {
				font-size: 14px;
				font-weight: 600;
			}
		}
		> .text {
			background-color: #e6f0ff;
			text-align: justify;
			padding: 8px 10px;
			border-radius: 3px;
			margin-top: 6px;
		}
		> .redpacket {
			margin-top: 6px;
			width: 225px;
			height: 85px;
			border-radius: 3px;
			background: url("../image/redpacket-bg.png");
			background-size: 100% 100%;
			> .redpacket-content {
				display: flex;
				box-sizing: border-box;
				margin-left: 10px;
				margin-right: 10px;
				width: calc(100% - 20px);
				padding-bottom: 12px;
				border-bottom: 1px solid rgba(255, 255, 255, 0.1);
				> .redpacket-icon {
					margin-top: 9px;
					width: 37px;
					height: 42px;
					> img {
						width: 100%;
						height: 100%;
					}
				}
				> .redpacket-desc {
					margin-left: 12px;
					margin-top: 14px;
					> .redpacket-title {
						width: 150px;
						font-size: 14px;
						font-weight: bold;
						color: #fff;
						text-align: left;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
					}
					> .recieve {
						margin-top: 8px;
						font-size: 10px;
						color: #fff;
						text-align: left;
					}
				}
			}
			> .redpacket-type {
				flex: 1;
				display: flex;
				margin-left: 12px;
				align-items: center;
				text-align: left;
				font-size: 10px;
				color: #fff;
				text-align: left;
			}
		}
	}
}
</style>
